import React, { FC, useContext } from 'react';
import styles from './index.module.scss';
import CardBox from '../CardBox';
import { Button } from '@maxtropy/components';
import { DoubleRightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import CustomTooltip from '../CustomTooltip';
import dayjs from 'dayjs';
import { DateContext } from '../../index';
import { IndexTimeActive } from '../SwitchDate';
import HighEnergyDevice from './HighEnergyDevice';
import HighEnergyPie from './HighEnergyPie';
import HighEnergyTrend from './HighEnergyTrend';
import DeviceDetail from './DeviceDetail';

const RightBox: FC = () => {
  const { activeKey, selectedDate } = useContext(DateContext);

  return (
    <div className={styles.right_wrapper}>
      {/* 设备能耗 80 */}
      <div className={styles.section_device}>
        <CardBox
          title={
            <>
              设备能耗
              <CustomTooltip placement="top" title="高能耗设备数据不包含今日">
                <InfoCircleOutlined
                  style={{
                    color: 'var(--warning-color)',
                    marginLeft: '6px',
                    fontSize: '16px',
                    verticalAlign: 'middle',
                  }}
                />
              </CustomTooltip>
            </>
          }
          titleRight={dayjs(selectedDate).format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
          extraContent={
            <Button type="link" style={{ padding: 0 }} onClick={() => window.open('/energy/equip/analysis', '_blank')}>
              高能耗设备分析
              <DoubleRightOutlined />
            </Button>
          }
        >
          <HighEnergyDevice />
        </CardBox>
      </div>

      {/* 设备用能对比 */}
      <div className={styles.section_pie}>
        <CardBox title="设备用能对比" titleType="simple">
          <HighEnergyPie />
        </CardBox>
      </div>

      {/* 设备用电趋势 */}
      <div className={styles.section_trend}>
        <CardBox title="设备用电趋势" titleType="simple">
          <HighEnergyTrend />
        </CardBox>
      </div>

      {/* 除湿机&VOCS */}
      <div className={styles.section_detail}>
        <CardBox title="除湿机&VOCS" titleType="simple">
          <DeviceDetail />
        </CardBox>
      </div>
    </div>
  );
};

export default RightBox;
